export default function () {
    const swiperOptions = {
        loop: 'infinite',
        effect: 'slide',
        autoplay: {
            delay: 35000,
            disableOnInteraction: false
        },
        //autoHeight:true,
        slidesPerView: 1,
        spaceBetween: 100,
        height: 500,

        // custom pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (i, className) {
                return `<button class="${className}">
            <svg class="progress" width="41" height="41"><circle class="circle-origin" r="20" cx="20.5" cy="20.5"></circle></svg><span><svg width="11" height="11"><circle cx="5" cy="5" r="5" fill="#fff"></circle></svg></span>
        </button>`;
            },
        
        },

        
    };
    new Swiper('.swiper-voice', swiperOptions);
}
